import { styled } from '@mui/material/styles';
import { flexRender } from '@tanstack/react-table';
import ArrowDropDownOutlinedIcon from '@mui/icons-material/ArrowDropDownOutlined';
import ArrowDropUpOutlinedIcon from '@mui/icons-material/ArrowDropUpOutlined';
import {
  Table as MUITable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import { DefaultFilter } from './filters';

const StyledTableRow = styled(TableRow)({
  '&:hover': {
    backgroundColor: '#F5F5F5',
  },
  cursor: 'pointer',
});

export default function DesktopTable({
  table,
  records,
  columnsConfig,
  onRowClick,
}) {
  function handleOnRowClick(_id) {
    const id = Number(_id);
    if (isNaN(id)) {
      console.error('Invalid id');
      return;
    }
    onRowClick({ data: records, id });
  }

  return (
    <TableContainer component={Paper} sx={{ margin: '0.5rem 0' }}>
      <MUITable>
        <TableHead>
          {table.getHeaderGroups().map((headerGroup) => (
            <TableRow key={headerGroup.id}>
              {headerGroup.headers.map((header, idx) => {
                return (
                  <TableCell
                    key={header.id}
                    colSpan={header.colSpan}
                    sx={{ whiteSpace: 'nowrap' }}
                  >
                    {header.isPlaceholder ? null : (
                      <div>
                        <div
                          onClick={header.column.getToggleSortingHandler()}
                          style={{
                            display: 'flex',
                            cursor: header.column.getCanSort() ? 'pointer' : '',
                            fontWeight: '600',
                          }}
                        >
                          {flexRender(
                            header.column.columnDef.header,
                            header.getContext()
                          )}
                          {{
                            asc: <ArrowDropUpOutlinedIcon />,
                            desc: <ArrowDropDownOutlinedIcon />,
                          }[header.column.getIsSorted()] ?? (
                            <div
                              style={{ height: '1.5rem', width: '1.5rem' }}
                            ></div>
                          )}
                        </div>
                        {header.column.getCanFilter() ? (
                          <div>
                            {columnsConfig[idx]?.filterComponent?.({
                              column: header.column,
                              id: header.id,
                            }) ?? (
                              <DefaultFilter
                                column={header.column}
                                id={header.id}
                              />
                            )}
                          </div>
                        ) : (
                          <div
                            style={{ width: '1rem', height: '2.5rem' }}
                          ></div>
                        )}
                      </div>
                    )}
                  </TableCell>
                );
              })}
            </TableRow>
          ))}
        </TableHead>
        <TableBody>
          {table.getRowModel().rows.map((row) => {
            return (
              <StyledTableRow
                key={row.id}
                onClick={() => handleOnRowClick(row.id)}
              >
                {row.getVisibleCells().map((cell) => {
                  return (
                    <TableCell
                      key={cell.id}
                      style={{ border: '1px solid #E0E0E0' }}
                    >
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </TableCell>
                  );
                })}
              </StyledTableRow>
            );
          })}
        </TableBody>
      </MUITable>
    </TableContainer>
  );
}
